import * as React from "react";
import type { SVGProps } from "react";
const SvgIconTopRated = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    role="img"
    focusable="false"
    width="100%"
    height="100%"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.9 8c0 3.81-3.09 6.9-6.9 6.9S1.1 11.8 1.1 8 4.2 1.1 8 1.1 14.9 4.2 14.9 8M9.19 6.46l-.91-1.84q-.04-.07-.12-.12T8 4.46q-.1 0-.16.05-.08.04-.12.13l-.9 1.83q-.04.07-.1.12-.07.05-.14.05l-2.03.3q-.08 0-.15.07-.07.06-.1.14v.16q.02.08.08.15l1.5 1.43q.04.06.06.13l-.01.15-.34 2.01q-.01.09.01.18.04.08.11.14.07.04.17.06.1 0 .17-.05l1.8-.95.15-.03q.07 0 .15.03l1.8.95q.08.05.17.05t.17-.06q.07-.06.1-.14.04-.09.02-.18l-.29-2.01q-.03-.07-.03-.14t.03-.14l1.5-1.42q.06-.07.09-.15v-.17q-.03-.08-.1-.14t-.16-.07l-2.03-.3q-.08-.01-.14-.06t-.1-.12"
      fill="#FFFFEA"
    />
    <path
      d="M8 14.9c3.81 0 6.9-3.09 6.9-6.9S11.8 1.1 8 1.1 1.1 4.2 1.1 8 4.2 14.9 8 14.9"
      stroke="#FFC107"
      strokeWidth={1.14}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="m8.28 4.36.9 1.84.1.11q.07.04.14.06l2.03.3q.09.01.16.07.06.06.1.14v.18q-.03.08-.1.14l-1.49 1.43q-.03.06-.03.13t.03.14l.29 2.02q.01.1-.01.17-.04.08-.11.14t-.17.06-.17-.04l-1.8-.96-.15-.03-.15.03-1.8.96q-.08.04-.17.04t-.17-.06-.1-.14-.02-.17l.34-2.02q.02-.07 0-.14 0-.08-.05-.13l-1.5-1.44q-.06-.06-.08-.14v-.17q.03-.08.1-.14.07-.05.15-.07l2.03-.3q.08 0 .14-.05l.1-.11.9-1.84q.05-.08.12-.13T8 4.2q.08 0 .16.05.07.04.12.12"
      fill="white"
    />
    <path
      d="m8.28 4.36.9 1.84.1.11q.07.04.14.06l2.03.3q.09.01.16.07.06.06.1.14v.18q-.03.08-.1.14l-1.49 1.43q-.03.06-.03.13t.03.14l.29 2.02q.01.1-.01.17-.04.08-.11.14t-.17.06-.17-.04l-1.8-.96-.15-.03-.15.03-1.8.96q-.08.04-.17.04t-.17-.06-.1-.14-.02-.17l.34-2.02q.02-.07 0-.14 0-.08-.05-.13l-1.5-1.44q-.06-.06-.08-.14v-.17q.03-.08.1-.14.07-.05.15-.07l2.03-.3q.08 0 .14-.05l.1-.11.9-1.84q.05-.08.12-.13T8 4.2q.08 0 .16.05.07.04.12.12"
      stroke="#FFC107"
      strokeWidth={1.14}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgIconTopRated;
